<template>
  <div class="relative z-0 flex items-center justify-between py-3" :class="{ 'px-4 sm:px-6': !transparent, 'lg:px-1': transparent }" v-if="total > 0">
    <div class="flex justify-between flex-1 sm:hidden">
      <button class="btn btn-secondary" @click="goToPage(currentPage - 1)">
        Previous
      </button>
      <button class="btn btn-secondary" @click="goToPage(currentPage + 1)">
        Next
      </button>
    </div>
    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between sm:flex-col lg:flex-row">
      <div>
        <p class="text-sm text-gray-700">
          Showing
          <span class="font-medium">{{ pageStart }}</span>
          to
          <span class="font-medium">{{ pageEnd }}</span>
          of
          <span class="font-medium">{{ total }}</span>
          results
        </p>
      </div>
      <div class="mt-2 lg:mt-0">
        <nav class="relative z-0 inline-flex shadow-sm">
          <button class="relative inline-flex items-center px-2 py-2 text-sm text-gray-400 rounded-r-none btn btn-outline focus:z-10" aria-label="Previous" @click="goToPage(currentPage - 1)">
            <fa :icon="['far', 'chevron-left']" fixed-width />
          </button>
          <template v-for="page in pages">
            <span v-if="page === null" :key="page" class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-400 bg-white border border-gray-200">
              ...
            </span>
            <div v-else-if="page === currentPage" :key="page" class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 transition duration-150 ease-in-out bg-gray-100 border border-gray-200">
              {{ page }}
            </div>
            <button v-else :key="page" class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-200 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-gray-500 focus:ring active:bg-gray-50 active:text-gray-700" @click="goToPage(page)">
              {{ page }}
            </button>
          </template>
          <button class="relative inline-flex items-center px-2 py-2 text-sm text-gray-400 border-l-0 rounded-l-none btn btn-outline focus:z-10" aria-label="Next" @click="goToPage(currentPage + 1)">
            <fa :icon="['far', 'chevron-right']" fixed-width />
          </button>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Pagination',

    props: {
      total: {
        type: Number,
        default: 1,
      },
      
      perPage: {
        type: Number,
        default: 50,
      },
      
      currentPage: {
        type: Number,
        default: 1
      },

      transparent: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      totalPages () {
        return Math.ceil(this.total / this.perPage)
      },

      pageStart () {
        if (this.currentPage === null) {
          return 1
        } else {
          return this.perPage * this.currentPage - (this.perPage - 1)
        }
        
      },

      pageEnd () {
        if (this.currentPage === null) {
          return this.total
        } else {
          return this.perPage * this.currentPage > this.total ? this.total : this.perPage * this.currentPage
        }
      },

      pages () {
        let array = []

        // If less than 6 pages, just show them all!
        if (this.totalPages < 6) {
          for (let i = 0; i < this.totalPages; i++) {
            array.push(i + 1)
          }

          return array
        }

        // Add all pages
        for (let i = 0; i < this.totalPages; i++) {
          array.push(i + 1)
        }

        // Filter out pages we don't want
        array = array.filter((i) => {
          return (i === 1 || i === this.totalPages || (i > (this.currentPage - 2) && i < (this.currentPage + 2)))
        })

        // Insert ellipsis points
        if (this.currentPage > 1 + 2) {
          array.splice(1, 0, null)
        }

        if (this.currentPage < this.totalPages - 2) {
          array.splice(array.length - 1, 0, null)
        }

        return array
      }
    },

    methods: {
      goToPage (page) {
        if (page === 0 || page > this.totalPages) {
          return
        }
        
        if (this.$route.query.page !== page) {
          this.$router.push({ query: { ...this.$route.query, page } })
          this.$emit('go', page)
        }
      }
    }
  }
</script>